import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
import { ImageAssetFieldsFragmentDoc } from './imageAssetFields.generated';
export type BingoFieldsFragment = { __typename?: 'bingos', id: string, roomID: string, min_bet?: string | null, max_bet?: string | null, number_of_balls?: number | null, SEO_title?: string | null, SEO_description?: string | null, translations?: Array<{ __typename?: 'bingos_translations_1', slug: string, display_name: string, long_desc?: string | null, rules?: string | null, cta_text?: string | null } | null> | null, img?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, img_wide?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, img_box?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, img_tall?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, img_banner?: { __typename?: 'directus_files', id: string, filename_disk?: string | null, title?: string | null, width?: number | null, height?: number | null } | null, tags?: Array<{ __typename?: 'bingos_game_tags_1', game_tags_id?: { __typename?: 'game_tags', translations?: Array<{ __typename?: 'game_tags_translations', name?: string | null } | null> | null } | null } | null> | null, brand?: { __typename?: 'Brand', value: string } | null, features?: Array<{ __typename?: 'bingos_game_features', game_features_id?: { __typename?: 'game_features', thumbnail?: { __typename?: 'directus_files', width?: number | null, height?: number | null, title?: string | null, filename_disk?: string | null } | null, translations?: Array<{ __typename?: 'game_features_translations', display_name?: string | null, description?: string | null } | null> | null } | null } | null> | null };

export const BingoFieldsFragmentDoc = gql`
    fragment BingoFields on bingos {
  id
  translations(
    filter: {languages_language_code: {language_code: {_eq: $language}}}
  ) {
    slug
    display_name
    long_desc
    rules
    cta_text
  }
  img {
    ...ImageAssetFields
  }
  img_wide {
    ...ImageAssetFields
  }
  img_box {
    ...ImageAssetFields
  }
  img_tall {
    ...ImageAssetFields
  }
  img_banner {
    ...ImageAssetFields
  }
  tags {
    game_tags_id(filter: null) {
      translations(
        filter: {languages_language_code: {language_code: {_eq: $language}}}
      ) {
        name
      }
    }
  }
  roomID
  min_bet
  max_bet
  number_of_balls
  brand {
    value
  }
  features {
    game_features_id(
      filter: {translations: {languages_language_code: {language_code: {_eq: $language}}}}
    ) {
      thumbnail(filter: null) {
        width
        height
        title
        filename_disk
      }
      translations(
        filter: {languages_language_code: {language_code: {_eq: $language}}}
      ) {
        display_name
        description
      }
    }
  }
  SEO_title
  SEO_description
}
    ${ImageAssetFieldsFragmentDoc}`;